export const pricePointDefaultCurrency = 'usd'
export const pricePointCurrencySymbol = pricePointDefaultCurrency === 'usd' ? '$' : pricePointDefaultCurrency

export type PricePoint = {
  value: number
  currencyId: string
  description: string
}

export type PricePointMutation = {
  value: number
  currencyId?: string
  description: string
}
